import { type WebConfig } from "@koala/sdk";
import { Component } from "react";
import { type ConnectedProps, connect } from "react-redux";
import { compose } from "redux";
import { type InjectedFormProps, reduxForm } from "redux-form";
import { withTheme } from "styled-components";
import { DeliverySearchStoredAddresses } from "../storedAddresses";
import GoogleAutocomplete from "@/components/fulfillmentManager/deliveryManager/deliveryForm/googautocomplete";
import { locationsActions } from "@/redux/locations/actions";
import { type RootState } from "@/types/app";

interface ThemeProps {
  theme: WebConfig;
}

interface Props extends ReduxProps, ThemeProps, InjectedFormProps<any, Props> {
  loading: boolean;
}
class DeliverySearch extends Component<Props> {
  render() {
    const { loading, searchDeliveryCoverage, theme } = this.props;

    return (
      <>
        <GoogleAutocomplete
          loading={loading}
          apiKey={theme.locations.map_key}
          // Redux connect wraps action creators with dispatch, making return type void at runtime
          checkOrSearchDeliveryCoverage={
            searchDeliveryCoverage as (address: any) => void
          }
        />
        <DeliverySearchStoredAddresses />
      </>
    );
  }
}

const mapStateToProps = (state: RootState) => ({
  loading: state.app.locations.searchLoading,
});

const mapDispatchToProps = {
  searchDeliveryCoverage: locationsActions.searchDeliveryCoverage,
};

const connector = connect(mapStateToProps, mapDispatchToProps);
type ReduxProps = ConnectedProps<typeof connector>;
export default compose<any>(
  withTheme,
  connector,
  reduxForm<any, Props>({ form: "delivery-search" })
)(DeliverySearch);
